export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo y descripción */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10 rounded-full overflow-hidden flex items-center justify-center">
                <img 
                  src="https://static.readdy.ai/image/65388bb12ee513dcffc13c09740f68f7/8f780ed6b1c45f0786e7de84a9f8546e.jpeg" 
                  alt="MANUK Logo" 
                  className="w-full h-full object-cover"
                />
              </div>
              <h3 className="text-xl font-bold" style={{ fontFamily: '"Pacifico", serif' }}>
                Libros de Fieltro Mágicos
              </h3>
            </div>
            <p className="text-gray-300 mb-4 max-w-md">
              Creamos libros de fieltro únicos y educativos para estimular la imaginación y el aprendizaje de los más pequeños. Cada libro está hecho a mano con amor y materiales de la más alta calidad.
            </p>
            <div className="flex space-x-4">
              <a href="https://www.facebook.com/manuklibrossensorialesfieltro?locale=es_LA" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-pink-400 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="https://www.instagram.com/librosdidacticosdefieltro" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-pink-400 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a href="https://www.youtube.com/@ManukLibrosSensoriales" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-pink-400 transition-colors cursor-pointer">
                <i className="ri-youtube-line text-xl"></i>
              </a>
            </div>
          </div>

          {/* Enlaces rápidos */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Enlaces Rápidos</h4>
            <ul className="space-y-2">
              <li><a href="#productos" className="text-gray-300 hover:text-pink-400 transition-colors cursor-pointer">Productos</a></li>
              <li><a href="#sobre-nosotros" className="text-gray-300 hover:text-pink-400 transition-colors cursor-pointer">Sobre Nosotros</a></li>
              <li><a href="#contacto" className="text-gray-300 hover:text-pink-400 transition-colors cursor-pointer">Contacto</a></li>
            </ul>
          </div>

          {/* Información de contacto */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contacto</h4>
            <ul className="space-y-2">
              <li className="flex items-center space-x-2">
                <i className="ri-mail-line text-pink-400"></i>
                <span className="text-gray-300">tejiendolunas2@gmail.com</span>
              </li>
              <li className="flex items-center space-x-2">
                <a 
                  href="https://wa.me/5491166477852" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="flex items-center space-x-2 hover:text-pink-400 transition-colors cursor-pointer"
                >
                  <i className="ri-whatsapp-line text-pink-400 text-xl"></i>
                  <span className="text-gray-300">+54 9 11 6647 7852</span>
                </a>
              </li>
              <li className="flex items-center space-x-2">
                <i className="ri-time-line text-pink-400"></i>
                <span className="text-gray-300">Lun-Vie: 9:00-18:00</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 Libros de Fieltro Mágicos. Todos los derechos reservados.
          </p>
          <div className="flex items-center space-x-4 mt-4 md:mt-0">
            <a href="#" className="text-gray-400 hover:text-pink-400 text-sm transition-colors cursor-pointer">Política de Privacidad</a>
            <a href="#" className="text-gray-400 hover:text-pink-400 text-sm transition-colors cursor-pointer">Términos de Uso</a>
            <a href="https://readdy.ai/?origin=logo" className="text-gray-400 hover:text-pink-400 text-sm transition-colors cursor-pointer">Powered by Readdy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}